module.exports = __webpack_public_path__ + "img/flat_war1.107c092e.jpg";